import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { reportFrontendCrash } from './app/services/diagnostics/kcc20-client-error-reporter.service';

if (typeof window !== 'undefined') {
  window.addEventListener('unhandledrejection', (event) =>
    reportFrontendCrash(event.reason),
  );
  window.addEventListener('error', (event) =>
    reportFrontendCrash(event.error ?? new Error('window error')),
  );
}

bootstrapApplication(AppComponent, appConfig).catch((err) => {
  reportFrontendCrash(err);
  console.error(err);
});
